import LinkCard from "components/LinkCard"
import useLaunchpadContext from "hooks/useLaunchpadContext"
import useRelativeTime from "hooks/useRelativeTime"
import ConventionSession from "models/convention-api/v1/ConventionSession"

interface ILaunchpadLiveSessionCard {
  session: ConventionSession
}

const LaunchpadLiveSessionCard = ({ session }: ILaunchpadLiveSessionCard) => {
  const { convention } = useLaunchpadContext()

  const { during: isSessionLive } = useRelativeTime({
    startAt: session.start_at,
    endAt: session.end_at,
  })

  const tag = isSessionLive ? "live" : "coming soon"

  return (
    <LinkCard
      key={session.id}
      imageUrl={session.promotional_image_url}
      headingText={`${session.start_at.format("MMM D, YYYY, h:mm a")} - ${session.end_at.format(
        "MMM D, YYYY, h:mm a z",
      )}`}
      title={session.name}
      subTitle={session.convention_exhibitor?.exhibitor_name || ""}
      redirect={`/conventions/${convention.id}/sessions/${session.id}`}
      tag={tag}
    />
  )
}

export default LaunchpadLiveSessionCard
